import { useState } from 'react'
import { SystemSkillsTab } from './SystemSkillsTab'
import { UserSkillsTab } from './UserSkillsTab'

type TabType = 'system' | 'users'

export function SkillsAdminView() {
  const [activeTab, setActiveTab] = useState<TabType>('system')

  return (
    <div className="admin-page" style={{ gap: 16, overflow: 'hidden' }}>
      <div className="admin-page-header">
        <div className="admin-page-title">
          <h1>Skills Management</h1>
          <p className="admin-page-subtitle">Manage system skill templates and view user skills</p>
        </div>
      </div>

      <div className="admin-tabs">
        <button
          className={`admin-tab ${activeTab === 'system' ? 'active' : ''}`}
          onClick={() => setActiveTab('system')}
        >
          System Skills
        </button>
        <button
          className={`admin-tab ${activeTab === 'users' ? 'active' : ''}`}
          onClick={() => setActiveTab('users')}
        >
          User Skills
        </button>
      </div>

      {activeTab === 'system' && <SystemSkillsTab />}
      {activeTab === 'users' && <UserSkillsTab />}
    </div>
  )
}
